'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Main = require('./Main');

var _Main2 = _interopRequireDefault(_Main);

var _requireAuth = require('./requireAuth');

var _requireAuth2 = _interopRequireDefault(_requireAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _requireAuth2.default)(_Main2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Main/index.js
// module id = 1021
// module chunks = 0